import { ref } from "vue";

const justCreatedAiNodeId = ref<string>();

export function useJustCreatedAiNode() {
  function reset() {
    justCreatedAiNodeId.value = undefined;
  }

  return {
    id: justCreatedAiNodeId,
    reset,
  };
}
